const { REACT_APP_API_URL } = process.env;



const getAllCategoriesAdmin = async (payload) => {
  const { page = 1, limit = 10, token } = payload;
  
  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString()
  });
  
  const response = await fetch(
    `${REACT_APP_API_URL}expense-categories/admin/all?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};



/**
 * Get all default categories with pagination and search (admin only)
 * @param payload - Contains page, limit, search, transactionType, sortBy, sortOrder, includeDeleted, and token
 * @returns Promise with the API response
 * 
 * 
 */
const getAllCategoriesAdminDefault = async (payload) => {
  const { 
    page = 1, 
    limit = 10, 
    search = '', 
    transactionType, 
    sortBy = 'order', 
    sortOrder = 'asc', 
    includeDeleted = false, 
    token 
  } = payload;
  
  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    search,
    sortBy,
    sortOrder,
    includeDeleted: includeDeleted.toString()
  });
  
  if (transactionType) {
    queryParams.append('transactionType', transactionType);
  }
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Get default category by ID (admin only)
 * @param payload - Contains categoryId and token
 * @returns Promise with the API response
 */
const getCategoryByIdAdmin = async (payload) => {
  const { categoryId, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/${categoryId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Create new default category (admin only)
 * @param payload - Contains categoryData and token
 * @returns Promise with the API response
 */
const createCategoryAdmin = async (payload) => {
  const { categoryData, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(categoryData),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Update an expense category (admin only)
 * @param payload - Contains categoryId, categoryData, and token
 * @returns Promise with the API response
 */
const updateCategoryAdmin = async (payload) => {
  const { categoryId, categoryData, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/${categoryId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(categoryData),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Soft delete default category (admin only)
 * @param payload - Contains categoryId and token
 * @returns Promise with the API response
 */
const deleteCategoryAdmin = async (payload) => {
  const { categoryId, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/${categoryId}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Restore deleted category (admin only)
 * @param payload - Contains categoryId and token
 * @returns Promise with the API response
 */
const restoreCategoryAdmin = async (payload) => {
  const { categoryId, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/${categoryId}/restore`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Update category order (admin only)
 * @param payload - Contains categories array and token
 * @returns Promise with the API response
 */
const updateCategoryOrderAdmin = async (payload) => {
  const { categories, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/order`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ categories }),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Get category statistics (admin only)
 * @param payload - Contains token
 * @returns Promise with the API response
 */
const getCategoryStatsAdmin = async (payload) => {
  const { token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/stats`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Bulk operations on categories (admin only)
 * @param payload - Contains operation, categoryIds, data, and token
 * @returns Promise with the API response
 */
const bulkOperationsCategoryAdmin = async (payload) => {
  const { operation, categoryIds, data, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/bulk`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ operation, categoryIds, data }),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Seed default categories (admin only)
 * @param payload - Contains token
 * @returns Promise with the API response
 */
const seedDefaultCategoriesAdmin = async (payload) => {
  const { token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}api/category-admin/seed`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

export {
  getAllCategoriesAdmin,
  getAllCategoriesAdminDefault,
  getCategoryByIdAdmin,
  createCategoryAdmin,
  updateCategoryAdmin,
  deleteCategoryAdmin,
  restoreCategoryAdmin,
  updateCategoryOrderAdmin,
  getCategoryStatsAdmin,
  bulkOperationsCategoryAdmin,
  seedDefaultCategoriesAdmin
};